import { render } from "./filter_offers.svg?vue&type=template&id=3a743870?inline"
const script = {}
script.render = render

export default script